/* eslint-disable import/no-cycle */
/* eslint-disable react/prop-types */
import React, { useRef, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getCatalog } from '../../../store/externalCalls/api/listTableApi';
import { composeURL } from '../../../utils/urlTools';
import './previewPosterMatrixModal.scss'
import { Col, Container, Row } from 'react-bootstrap';
import GridPanel from '../../molecules/gridPanel/gridPanel';
const PreviewPosterMatrix = (props) => {
  const {
    title,
    onClose,
    configFile,
    data,
  } = props;

  const params = useParams();
  const [dataPaginated, setData] = useState(undefined);
  const session = useSelector((state) => state.session);
  const id = configFile.idAttribute !== undefined
    ? params[configFile.idAttribute] : undefined;

  useEffect(() => {
    if (configFile.getURL !== undefined) {
      getCatalog(composeURL(session, configFile.sessionParams, configFile.getURL, id)).then((response) => {
        setData(response);
      });
    }
  }, [configFile]);

  return (
      <Container fluid>
         <Row className='grid-row'>
          {(Object.keys(data).map((panel, index) => (
                <Col className="grid-column" key={"sports-room-panel-preview-"+index}>
                  <GridPanel 
                    configFile={configFile}
                    placement={index}
                    value={data[index]}
                    isPreview={true}
                  ></GridPanel>
                </Col>
            )))}
        </Row>   
      </Container>
  );
};

PreviewPosterMatrix.propTypes = {
  /**
   * Modal title
   */
  title: PropTypes.string,
  /**
   * Event callback when the modal is closed
   */
  onClose: PropTypes.func,
  /**
   * Configuration file to create a table
   */
  configFile: PropTypes.shape({}),
};

PreviewPosterMatrix.defaultProps = {
  title: '',
  onClose: () => { },
  configFile: {},
};

export default PreviewPosterMatrix;
